import { render } from "./BaseDeleteIconButton.vue?vue&type=template&id=e9042438&scoped=true"
import script from "./BaseDeleteIconButton.vue?vue&type=script&lang=js"
export * from "./BaseDeleteIconButton.vue?vue&type=script&lang=js"

import "./BaseDeleteIconButton.vue?vue&type=style&index=0&id=e9042438&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9042438"]])

export default __exports__